module.exports = __webpack_public_path__ + "img/蒙版分组 (2).612f0344.png";